var map = {
	"./Aircraft/Airliner_Black.png": 59,
	"./Aircraft/Airliner_Blue.png": 1023,
	"./Aircraft/Airliner_Green.png": 1024,
	"./Aircraft/Airliner_Grey.png": 1025,
	"./Aircraft/Airliner_Red.png": 1026,
	"./Aircraft/Airliner_Yellow.png": 1027,
	"./Aircraft/Airplane_Black.png": 1028,
	"./Aircraft/Airplane_Blue.png": 1029,
	"./Aircraft/Airplane_Green.png": 1030,
	"./Aircraft/Airplane_Grey.png": 1031,
	"./Aircraft/Airplane_Red.png": 1032,
	"./Aircraft/Airplane_Yellow.png": 1033,
	"./Aircraft/Helicopter_Black.png": 1034,
	"./Aircraft/Helicopter_Blue.png": 1035,
	"./Aircraft/Helicopter_Green.png": 1036,
	"./Aircraft/Helicopter_Grey.png": 1037,
	"./Aircraft/Helicopter_Red.png": 1038,
	"./Aircraft/Helicopter_Yellow.png": 1039,
	"./Arrows/093-chevron-1.png": 1040,
	"./Arrows/093-chevron-10.png": 1041,
	"./Arrows/093-chevron-11.png": 1042,
	"./Arrows/093-chevron-2.png": 1043,
	"./Arrows/093-chevron-3.png": 1044,
	"./Arrows/093-chevron-4.png": 1045,
	"./Arrows/093-chevron-5.png": 1046,
	"./Arrows/093-chevron-6.png": 1047,
	"./Arrows/093-chevron-7.png": 1048,
	"./Arrows/093-chevron-8.png": 1049,
	"./Arrows/093-chevron-9.png": 1050,
	"./Arrows/093-chevron.png": 1051,
	"./Arrows/093-compress-1.png": 1052,
	"./Arrows/093-compress.png": 1053,
	"./Arrows/093-curved-arrow-1.png": 1054,
	"./Arrows/093-curved-arrow-2.png": 1055,
	"./Arrows/093-curved-arrow-3.png": 1056,
	"./Arrows/093-curved-arrow.png": 1057,
	"./Arrows/093-diagonal-arrow-1.png": 1058,
	"./Arrows/093-diagonal-arrow-10.png": 1059,
	"./Arrows/093-diagonal-arrow-11.png": 1060,
	"./Arrows/093-diagonal-arrow-12.png": 1061,
	"./Arrows/093-diagonal-arrow-13.png": 1062,
	"./Arrows/093-diagonal-arrow-14.png": 1063,
	"./Arrows/093-diagonal-arrow-15.png": 1064,
	"./Arrows/093-diagonal-arrow-2.png": 1065,
	"./Arrows/093-diagonal-arrow-3.png": 1066,
	"./Arrows/093-diagonal-arrow-4.png": 1067,
	"./Arrows/093-diagonal-arrow-5.png": 1068,
	"./Arrows/093-diagonal-arrow-6.png": 1069,
	"./Arrows/093-diagonal-arrow-7.png": 1070,
	"./Arrows/093-diagonal-arrow-8.png": 1071,
	"./Arrows/093-diagonal-arrow-9.png": 1072,
	"./Arrows/093-diagonal-arrow.png": 1073,
	"./Arrows/093-down-arrow-1.png": 1074,
	"./Arrows/093-down-arrow-2.png": 1075,
	"./Arrows/093-down-arrow-3.png": 1076,
	"./Arrows/093-down-arrow-4.png": 1077,
	"./Arrows/093-down-arrow-5.png": 1078,
	"./Arrows/093-down-arrow.png": 1079,
	"./Arrows/093-exchange-1.png": 1080,
	"./Arrows/093-exchange.png": 1081,
	"./Arrows/093-expand-1.png": 1082,
	"./Arrows/093-expand-2.png": 1083,
	"./Arrows/093-expand-3.png": 1084,
	"./Arrows/093-expand.png": 1085,
	"./Arrows/093-left-arrow-1.png": 1086,
	"./Arrows/093-left-arrow-2.png": 1087,
	"./Arrows/093-left-arrow-3.png": 1088,
	"./Arrows/093-left-arrow-4.png": 1089,
	"./Arrows/093-left-arrow-5.png": 1090,
	"./Arrows/093-left-arrow-6.png": 1091,
	"./Arrows/093-left-arrow.png": 1092,
	"./Arrows/093-move-1.png": 1093,
	"./Arrows/093-move.png": 1094,
	"./Arrows/093-redo-1.png": 1095,
	"./Arrows/093-redo.png": 1096,
	"./Arrows/093-resize-1.png": 1097,
	"./Arrows/093-resize-2.png": 1098,
	"./Arrows/093-resize-3.png": 1099,
	"./Arrows/093-resize.png": 1100,
	"./Arrows/093-right-arrow-1.png": 1101,
	"./Arrows/093-right-arrow-2.png": 1102,
	"./Arrows/093-right-arrow-3.png": 1103,
	"./Arrows/093-right-arrow-4.png": 1104,
	"./Arrows/093-right-arrow-5.png": 1105,
	"./Arrows/093-right-arrow-6.png": 1106,
	"./Arrows/093-right-arrow-7.png": 1107,
	"./Arrows/093-right-arrow.png": 1108,
	"./Arrows/093-scroll-1.png": 1109,
	"./Arrows/093-scroll.png": 1110,
	"./Arrows/093-sort-1.png": 1111,
	"./Arrows/093-sort-2.png": 1112,
	"./Arrows/093-sort-3.png": 1113,
	"./Arrows/093-sort.png": 1114,
	"./Arrows/093-turn-left-1.png": 1115,
	"./Arrows/093-turn-left-2.png": 1116,
	"./Arrows/093-turn-left-3.png": 1117,
	"./Arrows/093-turn-left.png": 1118,
	"./Arrows/093-turn-right-1.png": 1119,
	"./Arrows/093-turn-right-2.png": 1120,
	"./Arrows/093-turn-right-3.png": 1121,
	"./Arrows/093-turn-right.png": 1122,
	"./Arrows/093-undo-1.png": 1123,
	"./Arrows/093-undo.png": 1124,
	"./Arrows/093-up-arrow-1.png": 1125,
	"./Arrows/093-up-arrow-2.png": 1126,
	"./Arrows/093-up-arrow-3.png": 1127,
	"./Arrows/093-up-arrow-4.png": 1128,
	"./Arrows/093-up-arrow-5.png": 1129,
	"./Arrows/093-up-arrow-6.png": 1130,
	"./Arrows/093-up-arrow.png": 1131,
	"./Assets/151-actions.png": 1132,
	"./Assets/151-advert.png": 1133,
	"./Assets/151-antennas.png": 1134,
	"./Assets/151-archives.png": 1135,
	"./Assets/151-attached.png": 1136,
	"./Assets/151-banker.png": 1137,
	"./Assets/151-barrow.png": 1138,
	"./Assets/151-bed-side.png": 1139,
	"./Assets/151-beds.png": 1140,
	"./Assets/151-blackboard.png": 1141,
	"./Assets/151-blocked.png": 1142,
	"./Assets/151-book-bag-1.png": 1143,
	"./Assets/151-book-bag.png": 1144,
	"./Assets/151-bridges.png": 1145,
	"./Assets/151-calculations.png": 1146,
	"./Assets/151-carrier.png": 1147,
	"./Assets/151-ceremonial.png": 1148,
	"./Assets/151-chairs.png": 1149,
	"./Assets/151-cleaned.png": 1150,
	"./Assets/151-closing.png": 1151,
	"./Assets/151-cooling.png": 1152,
	"./Assets/151-demostration.png": 1153,
	"./Assets/151-deposit.png": 1154,
	"./Assets/151-dialogue.png": 1155,
	"./Assets/151-disturbance.png": 1156,
	"./Assets/151-domestic-phone.png": 1157,
	"./Assets/151-door-key.png": 1158,
	"./Assets/151-door.png": 1159,
	"./Assets/151-doorway.png": 1160,
	"./Assets/151-draws.png": 1161,
	"./Assets/151-driller.png": 1162,
	"./Assets/151-electric-1.png": 1163,
	"./Assets/151-electric-2.png": 1164,
	"./Assets/151-electric.png": 1165,
	"./Assets/151-entrance.png": 1166,
	"./Assets/151-facade-1.png": 1167,
	"./Assets/151-facade.png": 1168,
	"./Assets/151-fader.png": 1169,
	"./Assets/151-file-storage.png": 1170,
	"./Assets/151-fireplace-1.png": 1171,
	"./Assets/151-fireplace.png": 1172,
	"./Assets/151-flats-1.png": 1173,
	"./Assets/151-flats.png": 1174,
	"./Assets/151-frame.png": 1175,
	"./Assets/151-garden-work.png": 1176,
	"./Assets/151-gardener.png": 1177,
	"./Assets/151-gardening.png": 1178,
	"./Assets/151-glamour.png": 1179,
	"./Assets/151-graphic-design.png": 1180,
	"./Assets/151-graphs.png": 1181,
	"./Assets/151-hacksaw.png": 1182,
	"./Assets/151-hand-gesture.png": 1183,
	"./Assets/151-hand-phones.png": 1184,
	"./Assets/151-headphones.png": 1185,
	"./Assets/151-health-care.png": 1186,
	"./Assets/151-hearth.png": 1187,
	"./Assets/151-house-things-1.png": 1188,
	"./Assets/151-house-things-2.png": 1189,
	"./Assets/151-house-things.png": 1190,
	"./Assets/151-house.png": 1191,
	"./Assets/151-houses.png": 1192,
	"./Assets/151-indoor.png": 1193,
	"./Assets/151-industrial-park.png": 1194,
	"./Assets/151-industrial.png": 1195,
	"./Assets/151-interior-design.png": 1196,
	"./Assets/151-invention.png": 1197,
	"./Assets/151-keyword.png": 1198,
	"./Assets/151-kilograms.png": 1199,
	"./Assets/151-ladders.png": 1200,
	"./Assets/151-line-chart.png": 1201,
	"./Assets/151-lover.png": 1202,
	"./Assets/151-mail.png": 1203,
	"./Assets/151-mailed.png": 1204,
	"./Assets/151-mallet.png": 1205,
	"./Assets/151-mansory.png": 1206,
	"./Assets/151-maps-and-flags-1.png": 1207,
	"./Assets/151-maps-and-flags-2.png": 1208,
	"./Assets/151-maps-and-flags-3.png": 1209,
	"./Assets/151-maps-and-flags-4.png": 1210,
	"./Assets/151-maps-and-flags-5.png": 1211,
	"./Assets/151-maps-and-flags-6.png": 1212,
	"./Assets/151-maps-and-flags.png": 1213,
	"./Assets/151-measuring-1.png": 1214,
	"./Assets/151-measuring.png": 1215,
	"./Assets/151-mechanics.png": 1216,
	"./Assets/151-metallic-blind.png": 1217,
	"./Assets/151-money-icons.png": 1218,
	"./Assets/151-monumental.png": 1219,
	"./Assets/151-motorhome.png": 1220,
	"./Assets/151-online-store.png": 1221,
	"./Assets/151-packaging.png": 1222,
	"./Assets/151-paint-roller.png": 1223,
	"./Assets/151-painted.png": 1224,
	"./Assets/151-paper-printer.png": 1225,
	"./Assets/151-paper-work.png": 1226,
	"./Assets/151-picket.png": 1227,
	"./Assets/151-pincers.png": 1228,
	"./Assets/151-plan.png": 1229,
	"./Assets/151-plans.png": 1230,
	"./Assets/151-plumbering-1.png": 1231,
	"./Assets/151-plumbering.png": 1232,
	"./Assets/151-printed.png": 1233,
	"./Assets/151-property.png": 1234,
	"./Assets/151-pruners.png": 1235,
	"./Assets/151-purses.png": 1236,
	"./Assets/151-radiators.png": 1237,
	"./Assets/151-reading-glasses.png": 1238,
	"./Assets/151-real-estate-1.png": 1239,
	"./Assets/151-real-estate-2.png": 1240,
	"./Assets/151-real-estate-3.png": 1241,
	"./Assets/151-real-estate-4.png": 1242,
	"./Assets/151-real-estate-5.png": 1243,
	"./Assets/151-real-estate-6.png": 1244,
	"./Assets/151-real-estate.png": 1245,
	"./Assets/151-relax.png": 1246,
	"./Assets/151-religious.png": 1247,
	"./Assets/151-rent.png": 1248,
	"./Assets/151-reparation.png": 1249,
	"./Assets/151-roof.png": 1250,
	"./Assets/151-sand-clock.png": 1251,
	"./Assets/151-savings.png": 1252,
	"./Assets/151-security-system-1.png": 1253,
	"./Assets/151-security-system.png": 1254,
	"./Assets/151-seventeen.png": 1255,
	"./Assets/151-shower.png": 1256,
	"./Assets/151-single.png": 1257,
	"./Assets/151-sit-down.png": 1258,
	"./Assets/151-skyline.png": 1259,
	"./Assets/151-step-ladder.png": 1260,
	"./Assets/151-storehouse.png": 1261,
	"./Assets/151-studying.png": 1262,
	"./Assets/151-switch-off.png": 1263,
	"./Assets/151-text-file.png": 1264,
	"./Assets/151-title.png": 1265,
	"./Assets/151-tools-and-utensils.png": 1266,
	"./Assets/151-transportation.png": 1267,
	"./Assets/151-trees.png": 1268,
	"./Assets/151-trucks-1.png": 1269,
	"./Assets/151-trucks.png": 1270,
	"./Assets/151-turned-off.png": 1271,
	"./Assets/151-up-1.png": 1272,
	"./Assets/151-up-2.png": 1273,
	"./Assets/151-up.png": 1274,
	"./Assets/151-ventilation.png": 1275,
	"./Assets/151-wc.png": 1276,
	"./Assets/151-wheel-chair.png": 1277,
	"./Assets/151-wheelbarrow.png": 1278,
	"./Assets/151-winch.png": 1279,
	"./Assets/151-work-tools.png": 1280,
	"./Assets/151-worker.png": 1281,
	"./Bikes/Bicycle_Black.png": 1282,
	"./Bikes/Bicycle_Blue.png": 1283,
	"./Bikes/Bicycle_Green.png": 1284,
	"./Bikes/Bicycle_Grey.png": 1285,
	"./Bikes/Bicycle_Red.png": 1286,
	"./Bikes/Bicycle_Yellow.png": 1287,
	"./Bikes/CruiserMotorcycle_Black.png": 1288,
	"./Bikes/CruiserMotorcycle_Blue.png": 1289,
	"./Bikes/CruiserMotorcycle_Green.png": 1290,
	"./Bikes/CruiserMotorcycle_Grey.png": 1291,
	"./Bikes/CruiserMotorcycle_Red.png": 1292,
	"./Bikes/CruiserMotorcycle_Yellow.png": 1293,
	"./Bikes/Motorcycle_Black.png": 1294,
	"./Bikes/Motorcycle_Blue.png": 1295,
	"./Bikes/Motorcycle_Green.png": 1296,
	"./Bikes/Motorcycle_Grey.png": 1297,
	"./Bikes/Motorcycle_Red.png": 1298,
	"./Bikes/Motorcycle_Yellow.png": 1299,
	"./Bikes/QuadBike_Black.png": 1300,
	"./Bikes/QuadBike_Blue.png": 1301,
	"./Bikes/QuadBike_Green.png": 1302,
	"./Bikes/QuadBike_Grey.png": 1303,
	"./Bikes/QuadBike_Red.png": 1304,
	"./Bikes/QuadBike_Yellow.png": 1305,
	"./Bikes/Scooter_Black.png": 1306,
	"./Bikes/Scooter_Blue.png": 1307,
	"./Bikes/Scooter_Green.png": 1308,
	"./Bikes/Scooter_Grey.png": 1309,
	"./Bikes/Scooter_Red.png": 1310,
	"./Bikes/Scooter_Yellow.png": 1311,
	"./Bikes/TouringMotorcycle_Black.png": 1312,
	"./Bikes/TouringMotorcycle_Blue.png": 1313,
	"./Bikes/TouringMotorcycle_Gray.png": 1314,
	"./Bikes/TouringMotorcycle_Green.png": 1315,
	"./Bikes/TouringMotorcycle_Red.png": 1316,
	"./Bikes/TouringMotorcycle_Yellow.png": 1317,
	"./Car/Cabriolet_Black.png": 1318,
	"./Car/Cabriolet_Blue.png": 1319,
	"./Car/Cabriolet_Green.png": 1320,
	"./Car/Cabriolet_Grey.png": 1321,
	"./Car/Cabriolet_Red.png": 1322,
	"./Car/Cabriolet_Yellow.png": 1323,
	"./Car/CamperVan_Black.png": 1324,
	"./Car/CamperVan_Blue.png": 1325,
	"./Car/CamperVan_Green.png": 1326,
	"./Car/CamperVan_Grey.png": 1327,
	"./Car/CamperVan_Red.png": 1328,
	"./Car/CamperVan_Yellow.png": 1329,
	"./Car/Car_Black.png": 1330,
	"./Car/Car_Blue.png": 1331,
	"./Car/Car_Green.png": 1332,
	"./Car/Car_Grey.png": 1333,
	"./Car/Car_Red.png": 1334,
	"./Car/Car_Yellow.png": 1335,
	"./Car/ExecutiveCar_Black.png": 1336,
	"./Car/ExecutiveCar_Blue.png": 1337,
	"./Car/ExecutiveCar_Green.png": 1338,
	"./Car/ExecutiveCar_Grey.png": 1339,
	"./Car/ExecutiveCar_Red.png": 1340,
	"./Car/ExecutiveCar_Yellow.png": 1341,
	"./Car/Hatchback_Black.png": 1342,
	"./Car/Hatchback_Blue.png": 1343,
	"./Car/Hatchback_Green.png": 1344,
	"./Car/Hatchback_Grey.png": 1345,
	"./Car/Hatchback_Red.png": 1346,
	"./Car/Hatchback_Yellow.png": 1347,
	"./Car/HybridCar_Black.png": 1348,
	"./Car/HybridCar_Blue.png": 1349,
	"./Car/HybridCar_Green.png": 1350,
	"./Car/HybridCar_Grey.png": 1351,
	"./Car/HybridCar_Red.png": 1352,
	"./Car/HybridCar_Yellow.png": 1353,
	"./Car/Jeep_Black.png": 1354,
	"./Car/Jeep_Blue.png": 1355,
	"./Car/Jeep_Green.png": 1356,
	"./Car/Jeep_Grey.png": 1357,
	"./Car/Jeep_Red.png": 1358,
	"./Car/Jeep_Yellow.png": 1359,
	"./Car/Limousine_Black.png": 1360,
	"./Car/Limousine_Blue.png": 1361,
	"./Car/Limousine_Green.png": 1362,
	"./Car/Limousine_Grey.png": 1363,
	"./Car/Limousine_Red.png": 1364,
	"./Car/Limousine_Yellow.png": 1365,
	"./Car/LuxuryCar__Black.png": 1366,
	"./Car/LuxuryCar__Blue.png": 1367,
	"./Car/LuxuryCar__Gray.png": 1368,
	"./Car/LuxuryCar__Green.png": 1369,
	"./Car/LuxuryCar__Red.png": 1370,
	"./Car/LuxuryCar__Yellow.png": 1371,
	"./Car/MUV_Black.png": 1372,
	"./Car/MUV_Blue.png": 1373,
	"./Car/MUV_Green.png": 1374,
	"./Car/MUV_Grey.png": 1375,
	"./Car/MUV_Red.png": 1376,
	"./Car/MUV_Yellow.png": 1377,
	"./Car/Minibus_Black.png": 1378,
	"./Car/Minibus_Blue.png": 1379,
	"./Car/Minibus_Green.png": 1380,
	"./Car/Minibus_Grey.png": 1381,
	"./Car/Minibus_Red.png": 1382,
	"./Car/Minibus_Yellow.png": 1383,
	"./Car/MinicarTrailer_Black.png": 1384,
	"./Car/MinicarTrailer_Blue.png": 1385,
	"./Car/MinicarTrailer_Green.png": 1386,
	"./Car/MinicarTrailer_Grey.png": 1387,
	"./Car/MinicarTrailer_Red.png": 1388,
	"./Car/MinicarTrailer_Yellow.png": 1389,
	"./Car/Minicar_Black.png": 1390,
	"./Car/Minicar_Blue.png": 1391,
	"./Car/Minicar_Green.png": 1392,
	"./Car/Minicar_Grey.png": 1393,
	"./Car/Minicar_Red.png": 1394,
	"./Car/Minicar_Yellow.png": 1395,
	"./Car/Minitruck_Black.png": 1396,
	"./Car/Minitruck_Blue.png": 1397,
	"./Car/Minitruck_Green.png": 1398,
	"./Car/Minitruck_Grey.png": 1399,
	"./Car/Minitruck_Red.png": 1400,
	"./Car/Minitruck_Yellow.png": 1401,
	"./Car/PanelVan_Black.png": 1402,
	"./Car/PanelVan_Blue.png": 1403,
	"./Car/PanelVan_Green.png": 1404,
	"./Car/PanelVan_Grey.png": 1405,
	"./Car/PanelVan_Red.png": 1406,
	"./Car/PanelVan_Yellow.png": 1407,
	"./Car/Pickup_Black.png": 1408,
	"./Car/Pickup_Blue.png": 1409,
	"./Car/Pickup_Green.png": 1410,
	"./Car/Pickup_Grey.png": 1411,
	"./Car/Pickup_Red.png": 1412,
	"./Car/Pickup_Yellow.png": 1413,
	"./Car/SUV_Black.png": 1414,
	"./Car/SUV_Blue.png": 1415,
	"./Car/SUV_Green.png": 1416,
	"./Car/SUV_Grey.png": 1417,
	"./Car/SUV_Red.png": 1418,
	"./Car/SUV_Yellow.png": 1419,
	"./Car/ServiceVan_Black.png": 1420,
	"./Car/ServiceVan_Blue.png": 1421,
	"./Car/ServiceVan_Green.png": 1422,
	"./Car/ServiceVan_Grey.png": 1423,
	"./Car/ServiceVan_Red.png": 1424,
	"./Car/ServiceVan_Yellow.png": 1425,
	"./Car/SportsCar_Black.png": 1426,
	"./Car/SportsCar_Blue.png": 1427,
	"./Car/SportsCar_Green.png": 1428,
	"./Car/SportsCar_Grey.png": 1429,
	"./Car/SportsCar_Red.png": 1430,
	"./Car/SportsCar_Yellow.png": 1431,
	"./Car/StationWagon_Black.png": 1432,
	"./Car/StationWagon_Blue.png": 1433,
	"./Car/StationWagon_Green.png": 1434,
	"./Car/StationWagon_Grey.png": 1435,
	"./Car/StationWagon_Red.png": 1436,
	"./Car/StationWagon_Yellow.png": 1437,
	"./Car/Van_Black.png": 1438,
	"./Car/Van_Blue.png": 1439,
	"./Car/Van_Green.png": 1440,
	"./Car/Van_Grey.png": 1441,
	"./Car/Van_Red.png": 1442,
	"./Car/Van_Yellow.png": 1443,
	"./Ecommerce/auction.png": 1444,
	"./Ecommerce/badge-1.png": 1445,
	"./Ecommerce/badge-2.png": 1446,
	"./Ecommerce/badge-3.png": 1447,
	"./Ecommerce/badge-4.png": 1448,
	"./Ecommerce/badge.png": 1449,
	"./Ecommerce/barcode.png": 1450,
	"./Ecommerce/bedside-table.png": 1451,
	"./Ecommerce/billing-machine.png": 1452,
	"./Ecommerce/browser-1.png": 1453,
	"./Ecommerce/browser.png": 1454,
	"./Ecommerce/calculator.png": 1455,
	"./Ecommerce/cash-register.png": 1456,
	"./Ecommerce/click.png": 1457,
	"./Ecommerce/clock.png": 1458,
	"./Ecommerce/closed.png": 1459,
	"./Ecommerce/coin-1.png": 1460,
	"./Ecommerce/coin-stack.png": 1461,
	"./Ecommerce/coin.png": 1462,
	"./Ecommerce/comments.png": 1463,
	"./Ecommerce/compact-disc.png": 1464,
	"./Ecommerce/cosmetics.png": 1465,
	"./Ecommerce/coupon.png": 1466,
	"./Ecommerce/credit-card-1.png": 1467,
	"./Ecommerce/credit-card-2.png": 1468,
	"./Ecommerce/credit-card.png": 1469,
	"./Ecommerce/customer-service.png": 1470,
	"./Ecommerce/delivery-cart.png": 1471,
	"./Ecommerce/delivery-truck-1.png": 1472,
	"./Ecommerce/delivery-truck.png": 1473,
	"./Ecommerce/diamond.png": 1474,
	"./Ecommerce/discount.png": 1475,
	"./Ecommerce/email.png": 1476,
	"./Ecommerce/faq.png": 1477,
	"./Ecommerce/gift-card.png": 1478,
	"./Ecommerce/gift.png": 1479,
	"./Ecommerce/groceries.png": 1480,
	"./Ecommerce/help.png": 1481,
	"./Ecommerce/like.png": 1482,
	"./Ecommerce/money-bag.png": 1483,
	"./Ecommerce/money.png": 1484,
	"./Ecommerce/monitor.png": 1485,
	"./Ecommerce/news.png": 1486,
	"./Ecommerce/notepad.png": 1487,
	"./Ecommerce/online-shop-1.png": 1488,
	"./Ecommerce/online-shop-2.png": 1489,
	"./Ecommerce/online-shop-3.png": 1490,
	"./Ecommerce/online-shop.png": 1491,
	"./Ecommerce/open.png": 1492,
	"./Ecommerce/order.png": 1493,
	"./Ecommerce/package-1.png": 1494,
	"./Ecommerce/package-2.png": 1495,
	"./Ecommerce/package-3.png": 1496,
	"./Ecommerce/package.png": 1497,
	"./Ecommerce/padlock.png": 1498,
	"./Ecommerce/piggy-bank.png": 1499,
	"./Ecommerce/placeholder.png": 1500,
	"./Ecommerce/price-tag.png": 1501,
	"./Ecommerce/promotion.png": 1502,
	"./Ecommerce/purse.png": 1503,
	"./Ecommerce/qr-code.png": 1504,
	"./Ecommerce/receipt.png": 1505,
	"./Ecommerce/refund.png": 1506,
	"./Ecommerce/return.png": 1507,
	"./Ecommerce/review.png": 1508,
	"./Ecommerce/rocket-ship.png": 1509,
	"./Ecommerce/safebox.png": 1510,
	"./Ecommerce/search-1.png": 1511,
	"./Ecommerce/search.png": 1512,
	"./Ecommerce/shield.png": 1513,
	"./Ecommerce/shirt-1.png": 1514,
	"./Ecommerce/shirt.png": 1515,
	"./Ecommerce/shopping-bag-1.png": 1516,
	"./Ecommerce/shopping-bag-2.png": 1517,
	"./Ecommerce/shopping-bag.png": 1518,
	"./Ecommerce/shopping-basket-1.png": 1519,
	"./Ecommerce/shopping-basket-2.png": 1520,
	"./Ecommerce/shopping-basket-3.png": 1521,
	"./Ecommerce/shopping-basket-4.png": 1522,
	"./Ecommerce/shopping-basket.png": 1523,
	"./Ecommerce/shopping-cart-1.png": 1524,
	"./Ecommerce/shopping-cart-2.png": 1525,
	"./Ecommerce/shopping-cart-3.png": 1526,
	"./Ecommerce/shopping-cart-4.png": 1527,
	"./Ecommerce/shopping-cart.png": 1528,
	"./Ecommerce/smartphone-1.png": 1529,
	"./Ecommerce/smartphone.png": 1530,
	"./Ecommerce/star.png": 1531,
	"./Ecommerce/statistics.png": 1532,
	"./Ecommerce/stock-1.png": 1533,
	"./Ecommerce/stock-2.png": 1534,
	"./Ecommerce/stock.png": 1535,
	"./Ecommerce/stopwatch.png": 1536,
	"./Ecommerce/store.png": 1537,
	"./Ecommerce/survey.png": 1538,
	"./Ecommerce/user.png": 1539,
	"./Ecommerce/wallet.png": 1540,
	"./Ecommerce/wishlist-1.png": 1541,
	"./Ecommerce/wishlist.png": 1542,
	"./Ecommerce/worldwide.png": 1543,
	"./Emergencies/001-air-pump.png": 1544,
	"./Emergencies/002-helicopter.png": 1545,
	"./Emergencies/003-defibrillator.png": 1546,
	"./Emergencies/004-toolbox.png": 1547,
	"./Emergencies/005-smartphone.png": 1548,
	"./Emergencies/006-heart.png": 1549,
	"./Emergencies/007-hospital-2.png": 1550,
	"./Emergencies/008-tools.png": 1551,
	"./Emergencies/009-caution.png": 1552,
	"./Emergencies/010-hospital-1.png": 1553,
	"./Emergencies/011-pin.png": 1554,
	"./Emergencies/012-blood-transfusion.png": 1555,
	"./Emergencies/013-firefighter-1.png": 1556,
	"./Emergencies/014-barrier.png": 1557,
	"./Emergencies/015-fire-truck.png": 1558,
	"./Emergencies/016-police-badge.png": 1559,
	"./Emergencies/017-hospital.png": 1560,
	"./Emergencies/018-bucket.png": 1561,
	"./Emergencies/019-smoke-detector.png": 1562,
	"./Emergencies/020-shovel.png": 1563,
	"./Emergencies/021-walkie-talkie.png": 1564,
	"./Emergencies/022-firefighter.png": 1565,
	"./Emergencies/023-stretcher.png": 1566,
	"./Emergencies/024-lifebuoy.png": 1567,
	"./Emergencies/025-fire-extinguisher.png": 1568,
	"./Emergencies/026-warning.png": 1569,
	"./Emergencies/027-hydrant.png": 1570,
	"./Emergencies/028-matches.png": 1571,
	"./Emergencies/029-phone-call.png": 1572,
	"./Emergencies/030-life-jacket.png": 1573,
	"./Emergencies/031-band-aid.png": 1574,
	"./Emergencies/032-lighter.png": 1575,
	"./Emergencies/033-megaphone.png": 1576,
	"./Emergencies/034-sos.png": 1577,
	"./Emergencies/035-whistle.png": 1578,
	"./Emergencies/036-flashlight.png": 1579,
	"./Emergencies/037-sprinkler.png": 1580,
	"./Emergencies/038-fire-alarm-1.png": 1581,
	"./Emergencies/039-gas-mask.png": 1582,
	"./Emergencies/040-ambulance.png": 1583,
	"./Emergencies/041-emergency-call.png": 1584,
	"./Emergencies/042-first-aid-kit.png": 1585,
	"./Emergencies/043-fire.png": 1586,
	"./Emergencies/044-hose.png": 1587,
	"./Emergencies/045-exit.png": 1588,
	"./Emergencies/046-axe.png": 1589,
	"./Emergencies/047-cone.png": 1590,
	"./Emergencies/048-ladder.png": 1591,
	"./Emergencies/049-siren.png": 1592,
	"./Emergencies/050-fire-alarm.png": 1593,
	"./Family/001-couple-3.png": 1594,
	"./Family/002-house.png": 1595,
	"./Family/003-stroller.png": 1596,
	"./Family/004-son.png": 1597,
	"./Family/005-suitcase.png": 1598,
	"./Family/006-family-2.png": 1599,
	"./Family/007-pet-house.png": 1600,
	"./Family/008-cups.png": 1601,
	"./Family/009-photo-album.png": 1602,
	"./Family/010-fireplace.png": 1603,
	"./Family/011-pin.png": 1604,
	"./Family/012-insurance.png": 1605,
	"./Family/013-swing.png": 1606,
	"./Family/014-sofa.png": 1607,
	"./Family/015-couple-2.png": 1608,
	"./Family/016-home-1.png": 1609,
	"./Family/017-daughter.png": 1610,
	"./Family/018-gift-1.png": 1611,
	"./Family/019-shopping-basket.png": 1612,
	"./Family/020-television.png": 1613,
	"./Family/021-divorce.png": 1614,
	"./Family/022-picture-1.png": 1615,
	"./Family/023-briefcase.png": 1616,
	"./Family/024-graduate.png": 1617,
	"./Family/025-pacifier.png": 1618,
	"./Family/026-beach-ball.png": 1619,
	"./Family/027-love.png": 1620,
	"./Family/028-couple-1.png": 1621,
	"./Family/029-couple.png": 1622,
	"./Family/030-scooter.png": 1623,
	"./Family/031-gift.png": 1624,
	"./Family/032-picture.png": 1625,
	"./Family/033-wedding-rings.png": 1626,
	"./Family/034-wedding-cake.png": 1627,
	"./Family/035-newlyweds.png": 1628,
	"./Family/036-grave.png": 1629,
	"./Family/037-crib.png": 1630,
	"./Family/038-cat.png": 1631,
	"./Family/039-father.png": 1632,
	"./Family/040-dog.png": 1633,
	"./Family/041-care.png": 1634,
	"./Family/042-family-1.png": 1635,
	"./Family/043-grandparents.png": 1636,
	"./Family/044-family.png": 1637,
	"./Family/045-home.png": 1638,
	"./Family/046-motherhood.png": 1639,
	"./Family/047-grandfather.png": 1640,
	"./Family/048-grandmother.png": 1641,
	"./Family/049-newborn.png": 1642,
	"./Family/050-mother.png": 1643,
	"./GPS/compass-1.png": 1644,
	"./GPS/compass.png": 1645,
	"./GPS/gps.png": 1646,
	"./GPS/location-1.png": 1647,
	"./GPS/location-2.png": 1648,
	"./GPS/location-3.png": 1649,
	"./GPS/location.png": 124,
	"./GPS/location3.png": 1650,
	"./GPS/location_green.svg": 295,
	"./GPS/locations.png": 1651,
	"./GPS/map-1.png": 1652,
	"./GPS/map-2.png": 1653,
	"./GPS/map-3.png": 1654,
	"./GPS/map.png": 1655,
	"./GPS/navigator.png": 1656,
	"./GPS/panel.png": 1657,
	"./GPS/pin.png": 1658,
	"./GPS/placeholder-1.png": 1659,
	"./GPS/placeholder-2.png": 1660,
	"./GPS/placeholder-3.png": 1661,
	"./GPS/placeholder-4.png": 1662,
	"./GPS/placeholder-5.png": 1663,
	"./GPS/placeholder-6.png": 1664,
	"./GPS/placeholder-7.png": 1665,
	"./GPS/placeholder.png": 79,
	"./GPS/push-pin.png": 1666,
	"./GPS/route-1.png": 1667,
	"./GPS/route.png": 1668,
	"./GPS/satellite.png": 1669,
	"./GPS/selectLocation.svg": 143,
	"./GPS/smartphone-1.png": 1670,
	"./GPS/smartphone.png": 1671,
	"./GPS/target.png": 1672,
	"./Home/alarm-clock.png": 1673,
	"./Home/alcoholic-1.png": 1674,
	"./Home/alcoholic.png": 1675,
	"./Home/bake.png": 1676,
	"./Home/bathing.png": 1677,
	"./Home/bedroom-1.png": 1678,
	"./Home/bedroom-2.png": 1679,
	"./Home/bedroom-3.png": 1680,
	"./Home/bedroom-4.png": 1681,
	"./Home/bedroom-5.png": 1682,
	"./Home/bedroom-6.png": 1683,
	"./Home/bedroom.png": 1684,
	"./Home/bookcase.png": 1685,
	"./Home/carpenter.png": 1686,
	"./Home/carpet.png": 1687,
	"./Home/chairs-1.png": 1688,
	"./Home/chairs-2.png": 1689,
	"./Home/chairs.png": 1690,
	"./Home/chinese-food.png": 1691,
	"./Home/coffee-cup-1.png": 1692,
	"./Home/coffee-cup-2.png": 1693,
	"./Home/coffee-shop.png": 1694,
	"./Home/coffees.png": 1695,
	"./Home/comfortable-1.png": 1696,
	"./Home/comfortable.png": 1697,
	"./Home/coolnes.png": 1698,
	"./Home/couch.png": 1699,
	"./Home/door-key.png": 1700,
	"./Home/drinking.png": 1701,
	"./Home/elegant.png": 1702,
	"./Home/firefighting.png": 1703,
	"./Home/fry.png": 1704,
	"./Home/game-console.png": 1705,
	"./Home/garbage-bin.png": 1706,
	"./Home/gardening.png": 1707,
	"./Home/hair-salon.png": 1708,
	"./Home/hangers.png": 1709,
	"./Home/home-repair.png": 1710,
	"./Home/hot-drink.png": 1711,
	"./Home/hygienic-1.png": 1712,
	"./Home/hygienic.png": 1713,
	"./Home/invention.png": 1714,
	"./Home/japanese-food.png": 1715,
	"./Home/kitchen-pack-1.png": 1716,
	"./Home/kitchen-pack-10.png": 1717,
	"./Home/kitchen-pack-11.png": 1718,
	"./Home/kitchen-pack-12.png": 1719,
	"./Home/kitchen-pack-13.png": 1720,
	"./Home/kitchen-pack-14.png": 1721,
	"./Home/kitchen-pack-15.png": 1722,
	"./Home/kitchen-pack-16.png": 1723,
	"./Home/kitchen-pack-2.png": 1724,
	"./Home/kitchen-pack-3.png": 1725,
	"./Home/kitchen-pack-4.png": 1726,
	"./Home/kitchen-pack-5.png": 1727,
	"./Home/kitchen-pack-6.png": 1728,
	"./Home/kitchen-pack-7.png": 1729,
	"./Home/kitchen-pack-8.png": 1730,
	"./Home/kitchen-pack-9.png": 1731,
	"./Home/kitchen-pack.png": 1732,
	"./Home/kitchen-tools.png": 1733,
	"./Home/laptop-computer.png": 1734,
	"./Home/livingroom-1.png": 1735,
	"./Home/livingroom-2.png": 1736,
	"./Home/livingroom.png": 1737,
	"./Home/passkey.png": 1738,
	"./Home/phone-call.png": 1739,
	"./Home/phone-receiver.png": 1740,
	"./Home/plugging-1.png": 1741,
	"./Home/plugging.png": 1742,
	"./Home/protein.png": 1743,
	"./Home/real-estate-1.png": 1744,
	"./Home/real-estate-2.png": 1745,
	"./Home/real-estate-3.png": 1746,
	"./Home/real-estate.png": 1747,
	"./Home/reflecting.png": 1748,
	"./Home/refreshment.png": 1749,
	"./Home/restauran.png": 1750,
	"./Home/restroom.png": 1751,
	"./Home/seat.png": 1752,
	"./Home/seatting.png": 1753,
	"./Home/showers.png": 1754,
	"./Home/sinks.png": 1755,
	"./Home/sleepy.png": 1756,
	"./Home/studying-1.png": 1757,
	"./Home/studying-2.png": 1758,
	"./Home/studying.png": 1759,
	"./Home/supper.png": 1760,
	"./Home/technological.png": 1761,
	"./Home/televisions-1.png": 1762,
	"./Home/televisions.png": 1763,
	"./Home/ventilator.png": 1764,
	"./Home/wooden-chair.png": 1765,
	"./Home/yard.png": 1766,
	"./Hospital/ambulance.png": 1767,
	"./Hospital/band-aid.png": 1768,
	"./Hospital/bandage.png": 1769,
	"./Hospital/blood-donation.png": 1770,
	"./Hospital/blood-sample.png": 1771,
	"./Hospital/blood-transfusion.png": 1772,
	"./Hospital/broken-bone.png": 1773,
	"./Hospital/cardiogram.png": 1774,
	"./Hospital/clinic-history.png": 1775,
	"./Hospital/coffee-cup.png": 1776,
	"./Hospital/crutches.png": 1777,
	"./Hospital/dna.png": 1778,
	"./Hospital/doctor.png": 1779,
	"./Hospital/dropper.png": 1780,
	"./Hospital/electrocardiogram.png": 1781,
	"./Hospital/eye-drops.png": 1782,
	"./Hospital/eye.png": 1783,
	"./Hospital/first-aid-kit.png": 1784,
	"./Hospital/flask.png": 1785,
	"./Hospital/hospital-1.png": 1786,
	"./Hospital/hospital-2.png": 1787,
	"./Hospital/hospital-bed.png": 1788,
	"./Hospital/hospital.png": 1789,
	"./Hospital/id-card.png": 1790,
	"./Hospital/laptop.png": 1791,
	"./Hospital/mask.png": 1792,
	"./Hospital/medicine-1.png": 1793,
	"./Hospital/medicine-2.png": 1794,
	"./Hospital/medicine-3.png": 1795,
	"./Hospital/medicine-4.png": 1796,
	"./Hospital/medicine.png": 1797,
	"./Hospital/microscope.png": 1798,
	"./Hospital/nurse.png": 1799,
	"./Hospital/optometry.png": 1800,
	"./Hospital/pill.png": 1801,
	"./Hospital/pills-1.png": 1802,
	"./Hospital/pills.png": 1803,
	"./Hospital/placeholder.png": 1804,
	"./Hospital/prescription.png": 1805,
	"./Hospital/serum.png": 1806,
	"./Hospital/shirt.png": 1807,
	"./Hospital/smartphone.png": 1808,
	"./Hospital/stethoscope.png": 1809,
	"./Hospital/tag.png": 1810,
	"./Hospital/test-tube.png": 1811,
	"./Hospital/thermometer.png": 1812,
	"./Hospital/tooth.png": 1813,
	"./Hospital/vaccine.png": 1814,
	"./Hospital/virus.png": 1815,
	"./Hospital/weight.png": 1816,
	"./Lights/amber_light.png": 1817,
	"./Lights/green_light.png": 1818,
	"./Lights/grey_light.png": 1819,
	"./Lights/red_light.png": 1820,
	"./Lights/traffic_light_green.png": 1821,
	"./Lights/traffic_light_none.png": 1822,
	"./Lights/traffic_light_red.png": 1823,
	"./Lights/trafficlight.png": 1824,
	"./Lights/trafficlightcolour.png": 1825,
	"./Logistics/001-distribution-5.png": 1826,
	"./Logistics/002-aerial.png": 1827,
	"./Logistics/003-frontal-view.png": 1828,
	"./Logistics/004-distribution-4.png": 1829,
	"./Logistics/005-clipboards.png": 1830,
	"./Logistics/006-oceanic.png": 1831,
	"./Logistics/007-placeholders-1.png": 1832,
	"./Logistics/008-international.png": 1833,
	"./Logistics/009-packages-2.png": 1834,
	"./Logistics/010-tools-and-utensils-3.png": 1835,
	"./Logistics/011-weekly-calendar.png": 1836,
	"./Logistics/012-placeholders.png": 1837,
	"./Logistics/013-distribution-3.png": 1838,
	"./Logistics/014-shopping-carts-1.png": 1839,
	"./Logistics/015-maps-and-flags-1.png": 1840,
	"./Logistics/016-organizing.png": 1841,
	"./Logistics/017-maps-and-flags.png": 1842,
	"./Logistics/018-tools-and-utensils-2.png": 1843,
	"./Logistics/019-call-center-1.png": 1844,
	"./Logistics/020-protected.png": 1845,
	"./Logistics/021-cubes.png": 1846,
	"./Logistics/022-distribution-2.png": 1847,
	"./Logistics/023-call-center.png": 1848,
	"./Logistics/024-bussiness.png": 1849,
	"./Logistics/025-charter.png": 1850,
	"./Logistics/026-trolley-cart.png": 1851,
	"./Logistics/027-distribution-1.png": 1852,
	"./Logistics/028-tools-and-utensils-1.png": 1853,
	"./Logistics/029-airplanes.png": 1854,
	"./Logistics/030-verified.png": 1855,
	"./Logistics/031-shopping-carts.png": 1856,
	"./Logistics/032-transportation.png": 1857,
	"./Logistics/033-packages-1.png": 1858,
	"./Logistics/034-changing.png": 1859,
	"./Logistics/035-packages.png": 1860,
	"./Logistics/036-symbolic.png": 1861,
	"./Logistics/037-packing.png": 1862,
	"./Logistics/038-trucks.png": 1863,
	"./Logistics/039-tools-and-utensils.png": 1864,
	"./Logistics/040-circular-arrows.png": 1865,
	"./Logistics/041-debit-card.png": 1866,
	"./Logistics/042-24-hours.png": 1867,
	"./Logistics/043-distribution.png": 1868,
	"./Logistics/044-cargo-ship.png": 1869,
	"./Machinery/BackhoeLoader_Black.png": 1870,
	"./Machinery/BackhoeLoader_Blue.png": 1871,
	"./Machinery/BackhoeLoader_Green.png": 1872,
	"./Machinery/BackhoeLoader_Grey.png": 1873,
	"./Machinery/BackhoeLoader_Red.png": 1874,
	"./Machinery/BackhoeLoader_Yellow.png": 1875,
	"./Machinery/Bulldozer_Black.png": 1876,
	"./Machinery/Bulldozer_Blue.png": 1877,
	"./Machinery/Bulldozer_Green.png": 1878,
	"./Machinery/Bulldozer_Grey.png": 1879,
	"./Machinery/Bulldozer_Red.png": 1880,
	"./Machinery/Bulldozer_Yellow.png": 1881,
	"./Machinery/CompactExcavator_Black.png": 1882,
	"./Machinery/CompactExcavator_Blue.png": 1883,
	"./Machinery/CompactExcavator_Green.png": 1884,
	"./Machinery/CompactExcavator_Grey.png": 1885,
	"./Machinery/CompactExcavator_Red.png": 1886,
	"./Machinery/CompactExcavator_Yellow.png": 1887,
	"./Machinery/Excavator_Black.png": 1888,
	"./Machinery/Excavator_Blue.png": 1889,
	"./Machinery/Excavator_Green.png": 1890,
	"./Machinery/Excavator_Grey.png": 1891,
	"./Machinery/Excavator_Red.png": 1892,
	"./Machinery/Excavator_Yellow.png": 1893,
	"./Machinery/FarmTractor_Black.png": 1894,
	"./Machinery/FarmTractor_Blue.png": 1895,
	"./Machinery/FarmTractor_Green.png": 1896,
	"./Machinery/FarmTractor_Grey.png": 1897,
	"./Machinery/FarmTractor_Red.png": 1898,
	"./Machinery/FarmTractor_Yellow.png": 1899,
	"./Machinery/ForkliftTruck_Loaded_Black.png": 1900,
	"./Machinery/ForkliftTruck_Loaded_Blue.png": 1901,
	"./Machinery/ForkliftTruck_Loaded_Green.png": 1902,
	"./Machinery/ForkliftTruck_Loaded_Grey.png": 1903,
	"./Machinery/ForkliftTruck_Loaded_Red.png": 1904,
	"./Machinery/ForkliftTruck_Loaded_Yellow.png": 1905,
	"./Machinery/ForkliftTruck__Black.png": 1906,
	"./Machinery/ForkliftTruck__Blue.png": 1907,
	"./Machinery/ForkliftTruck__Green.png": 1908,
	"./Machinery/ForkliftTruck__Grey.png": 1909,
	"./Machinery/ForkliftTruck__Red.png": 1910,
	"./Machinery/ForkliftTruck__Yellow.png": 1911,
	"./Machinery/LandfillCompactor_Black.png": 1912,
	"./Machinery/LandfillCompactor_Blue.png": 1913,
	"./Machinery/LandfillCompactor_Green.png": 1914,
	"./Machinery/LandfillCompactor_Grey.png": 1915,
	"./Machinery/LandfillCompactor_Red.png": 1916,
	"./Machinery/LandfillCompactor_Yellow.png": 1917,
	"./Machinery/Loader_Black.png": 1918,
	"./Machinery/Loader_Blue.png": 1919,
	"./Machinery/Loader_Green.png": 1920,
	"./Machinery/Loader_Grey.png": 1921,
	"./Machinery/Loader_Red.png": 1922,
	"./Machinery/Loader_Yellow.png": 1923,
	"./Machinery/MaterialHandler_Black.png": 1924,
	"./Machinery/MaterialHandler_Blue.png": 1925,
	"./Machinery/MaterialHandler_Green.png": 1926,
	"./Machinery/MaterialHandler_Grey.png": 1927,
	"./Machinery/MaterialHandler_Red.png": 1928,
	"./Machinery/MaterialHandler_Yellow.png": 1929,
	"./Machinery/RoadRoller_Black.png": 1930,
	"./Machinery/RoadRoller_Blue.png": 1931,
	"./Machinery/RoadRoller_Green.png": 1932,
	"./Machinery/RoadRoller_Grey.png": 1933,
	"./Machinery/RoadRoller_Red.png": 1934,
	"./Machinery/RoadRoller_Yellow.png": 1935,
	"./Machinery/RoadSweeper_Black.png": 1936,
	"./Machinery/RoadSweeper_Blue.png": 1937,
	"./Machinery/RoadSweeper_Green.png": 1938,
	"./Machinery/RoadSweeper_Grey.png": 1939,
	"./Machinery/RoadSweeper_Red.png": 1940,
	"./Machinery/RoadSweeper_Yellow.png": 1941,
	"./Machinery/RollerCompactor_Black.png": 1942,
	"./Machinery/RollerCompactor_Blue.png": 1943,
	"./Machinery/RollerCompactor_Green.png": 1944,
	"./Machinery/RollerCompactor_Grey.png": 1945,
	"./Machinery/RollerCompactor_Red.png": 1946,
	"./Machinery/RollerCompactor_Yellow.png": 1947,
	"./Machinery/SkidSteerLoader_Black.png": 1948,
	"./Machinery/SkidSteerLoader_Blue.png": 1949,
	"./Machinery/SkidSteerLoader_Green.png": 1950,
	"./Machinery/SkidSteerLoader_Grey.png": 1951,
	"./Machinery/SkidSteerLoader_Red.png": 1952,
	"./Machinery/SkidSteerLoader_Yellow.png": 1953,
	"./Machinery/SkipLoader_Black.png": 1954,
	"./Machinery/SkipLoader_Blue.png": 1955,
	"./Machinery/SkipLoader_Green.png": 1956,
	"./Machinery/SkipLoader_Grey.png": 1957,
	"./Machinery/SkipLoader_Red.png": 1958,
	"./Machinery/SkipLoader_Yellow.png": 1959,
	"./Machinery/SoilStabilizer_Black.png": 1960,
	"./Machinery/SoilStabilizer_Blue.png": 1961,
	"./Machinery/SoilStabilizer_Green.png": 1962,
	"./Machinery/SoilStabilizer_Grey.png": 1963,
	"./Machinery/SoilStabilizer_Red.png": 1964,
	"./Machinery/SoilStabilizer_Yellow.png": 1965,
	"./Machinery/SteamRoller_Black.png": 1966,
	"./Machinery/SteamRoller_Blue.png": 1967,
	"./Machinery/SteamRoller_Green.png": 1968,
	"./Machinery/SteamRoller_Grey.png": 1969,
	"./Machinery/SteamRoller_Red.png": 1970,
	"./Machinery/SteamRoller_Yellow.png": 1971,
	"./Machinery/StreetSweeper_Black.png": 1972,
	"./Machinery/StreetSweeper_Blue.png": 1973,
	"./Machinery/StreetSweeper_Green.png": 1974,
	"./Machinery/StreetSweeper_Grey.png": 1975,
	"./Machinery/StreetSweeper_Red.png": 1976,
	"./Machinery/StreetSweeper_Yellow.png": 1977,
	"./Machinery/TelescopicHandler_Black.png": 1978,
	"./Machinery/TelescopicHandler_Blue.png": 1979,
	"./Machinery/TelescopicHandler_Green.png": 1980,
	"./Machinery/TelescopicHandler_Grey.png": 1981,
	"./Machinery/TelescopicHandler_Red.png": 1982,
	"./Machinery/TelescopicHandler_Yellow.png": 1983,
	"./Machinery/TruckMountedCrane_Working_Black.png": 1984,
	"./Machinery/TruckMountedCrane_Working_Blue.png": 1985,
	"./Machinery/TruckMountedCrane_Working_Green.png": 1986,
	"./Machinery/TruckMountedCrane_Working_Grey.png": 1987,
	"./Machinery/TruckMountedCrane_Working_Red.png": 1988,
	"./Machinery/TruckMountedCrane_Working_Yellow.png": 1989,
	"./Machinery/TruckMountedCrane__Black.png": 1990,
	"./Machinery/TruckMountedCrane__Blue.png": 1991,
	"./Machinery/TruckMountedCrane__Green.png": 1992,
	"./Machinery/TruckMountedCrane__Grey.png": 1993,
	"./Machinery/TruckMountedCrane__Red.png": 1994,
	"./Machinery/TruckMountedCrane__Yellow.png": 1995,
	"./Machinery/WheeledExcavator_Black.png": 1996,
	"./Machinery/WheeledExcavator_Blue.png": 1997,
	"./Machinery/WheeledExcavator_Green.png": 1998,
	"./Machinery/WheeledExcavator_Grey.png": 1999,
	"./Machinery/WheeledExcavator_Red.png": 2000,
	"./Machinery/WheeledExcavator_Yellow.png": 2001,
	"./Machinery/WreckingBall_Black.png": 2002,
	"./Machinery/WreckingBall_Blue.png": 2003,
	"./Machinery/WreckingBall_Green.png": 2004,
	"./Machinery/WreckingBall_Grey.png": 2005,
	"./Machinery/WreckingBall_Red.png": 2006,
	"./Machinery/WreckingBall_Yellow.png": 2007,
	"./Marine/001-pirate-3.png": 2008,
	"./Marine/001-whale.png": 2009,
	"./Marine/002-hook.png": 2010,
	"./Marine/002-lifesaver.png": 2011,
	"./Marine/003-round-shot.png": 2012,
	"./Marine/003-sailor-cap-2.png": 2013,
	"./Marine/004-anchor-2.png": 2014,
	"./Marine/004-starfish.png": 2015,
	"./Marine/005-anchor-1.png": 2016,
	"./Marine/005-cannon.png": 2017,
	"./Marine/006-dolphin.png": 2018,
	"./Marine/006-parrot.png": 2019,
	"./Marine/007-island.png": 2020,
	"./Marine/007-knot-1.png": 2021,
	"./Marine/008-pirate-2.png": 2022,
	"./Marine/008-sailor-cap-1.png": 2023,
	"./Marine/009-flag.png": 2024,
	"./Marine/009-key.png": 2025,
	"./Marine/010-barrel.png": 2026,
	"./Marine/010-seagull-1.png": 2027,
	"./Marine/011-boat.png": 2028,
	"./Marine/011-paddle.png": 2029,
	"./Marine/012-pirate-ship.png": 2030,
	"./Marine/012-porthole.png": 2031,
	"./Marine/013-bollard.png": 2032,
	"./Marine/013-gold-ingots.png": 2033,
	"./Marine/014-lighthouse-1.png": 2034,
	"./Marine/014-placeholder.png": 2035,
	"./Marine/015-buoys.png": 2036,
	"./Marine/015-skull-and-bones.png": 2037,
	"./Marine/016-flippers.png": 2038,
	"./Marine/016-sword.png": 2039,
	"./Marine/017-pirate-1.png": 2040,
	"./Marine/017-shirt.png": 2041,
	"./Marine/018-chains.png": 2042,
	"./Marine/018-pipe.png": 2043,
	"./Marine/019-eyepatch.png": 2044,
	"./Marine/019-pipe-1.png": 2045,
	"./Marine/020-compass-2.png": 2046,
	"./Marine/020-gallows.png": 2047,
	"./Marine/021-coin.png": 2048,
	"./Marine/021-radar-1.png": 2049,
	"./Marine/022-compass-1.png": 2050,
	"./Marine/022-rum.png": 2051,
	"./Marine/023-money-bag.png": 2052,
	"./Marine/023-radar.png": 2053,
	"./Marine/024-diving-helmet.png": 2054,
	"./Marine/024-pirate.png": 2055,
	"./Marine/025-bottle.png": 2056,
	"./Marine/025-treasure-map.png": 2057,
	"./Marine/026-captain.png": 2058,
	"./Marine/026-wooden-leg.png": 2059,
	"./Marine/027-helm.png": 2060,
	"./Marine/027-yatch.png": 2061,
	"./Marine/028-message-in-a-bottle.png": 2062,
	"./Marine/028-oars.png": 2063,
	"./Marine/029-lighthouse.png": 2064,
	"./Marine/029-ship.png": 2065,
	"./Marine/030-binoculars.png": 2066,
	"./Marine/030-torch.png": 2067,
	"./Marine/031-jolly-roger.png": 2068,
	"./Marine/031-propeller.png": 2069,
	"./Marine/032-bell.png": 2070,
	"./Marine/032-hook.png": 2071,
	"./Marine/033-dice.png": 2072,
	"./Marine/033-map.png": 2073,
	"./Marine/034-sailor-cap.png": 2074,
	"./Marine/034-telescope.png": 2075,
	"./Marine/035-knot.png": 2076,
	"./Marine/035-tortoise.png": 2077,
	"./Marine/036-letter.png": 2078,
	"./Marine/036-waves.png": 2079,
	"./Marine/037-anchor.png": 2080,
	"./Marine/037-pipe.png": 2081,
	"./Marine/038-compass.png": 2082,
	"./Marine/038-lifebuoy.png": 2083,
	"./Marine/039-bomb.png": 2084,
	"./Marine/039-rudder-1.png": 2085,
	"./Marine/040-sailboat.png": 2086,
	"./Marine/040-treasure.png": 2087,
	"./Marine/041-starfish.png": 2088,
	"./Marine/042-lighthouse.png": 2089,
	"./Marine/043-spyglass.png": 2090,
	"./Marine/044-fish.png": 2091,
	"./Marine/045-compass.png": 2092,
	"./Marine/046-anchor.png": 2093,
	"./Marine/047-seagull.png": 2094,
	"./Marine/048-rudder.png": 2095,
	"./Marine/049-snorkel.png": 2096,
	"./Marine/050-life-jacket.png": 2097,
	"./Military/001-knife.png": 2098,
	"./Military/002-bomb-1.png": 2099,
	"./Military/003-radar.png": 2100,
	"./Military/004-medal-1.png": 2101,
	"./Military/005-launcher-1.png": 2102,
	"./Military/006-helmet.png": 2103,
	"./Military/007-chamber.png": 2104,
	"./Military/008-helicopter.png": 2105,
	"./Military/009-soldier.png": 2106,
	"./Military/010-lieutenant.png": 2107,
	"./Military/011-shotgun.png": 2108,
	"./Military/012-backpack.png": 2109,
	"./Military/013-bomb-detonation-1.png": 2110,
	"./Military/014-bomb-detonation.png": 2111,
	"./Military/015-fighter-plane.png": 2112,
	"./Military/016-dynamite.png": 2113,
	"./Military/017-first-aid-kit-1.png": 2114,
	"./Military/018-boat.png": 2115,
	"./Military/019-submarine.png": 2116,
	"./Military/020-compass.png": 2117,
	"./Military/021-insignia.png": 2118,
	"./Military/022-first-aid-kit.png": 2119,
	"./Military/023-placeholder.png": 2120,
	"./Military/024-jet.png": 2121,
	"./Military/025-flag.png": 2122,
	"./Military/026-boots.png": 2123,
	"./Military/027-gas-mask.png": 2124,
	"./Military/028-bullet-1.png": 2125,
	"./Military/029-launcher.png": 2126,
	"./Military/030-satellite-dish.png": 2127,
	"./Military/031-parachute.png": 2128,
	"./Military/032-gun.png": 2129,
	"./Military/033-bulletproof.png": 2130,
	"./Military/034-swiss-army-knife.png": 2131,
	"./Military/035-bullet.png": 2132,
	"./Military/036-binoculars.png": 2133,
	"./Military/037-target.png": 2134,
	"./Military/038-walkie-talkie.png": 2135,
	"./Military/039-rank.png": 2136,
	"./Military/040-barbed.png": 2137,
	"./Military/041-bomb.png": 2138,
	"./Military/042-radiation.png": 2139,
	"./Military/043-chevron.png": 2140,
	"./Military/044-map.png": 2141,
	"./Military/045-medal.png": 2142,
	"./Military/046-tank.png": 2143,
	"./Military/047-tent.png": 2144,
	"./Military/048-dog-tags-military.png": 2145,
	"./Military/049-grenade.png": 2146,
	"./Military/050-badge.png": 2147,
	"./Multimedia/3d-glasses.png": 2148,
	"./Multimedia/antenna.png": 2149,
	"./Multimedia/camera-1.png": 2150,
	"./Multimedia/camera-2.png": 2151,
	"./Multimedia/camera-3.png": 2152,
	"./Multimedia/camera.png": 2153,
	"./Multimedia/cd.png": 2154,
	"./Multimedia/chat.png": 2155,
	"./Multimedia/clapperboard.png": 2156,
	"./Multimedia/cloud.png": 2157,
	"./Multimedia/compact-disc.png": 2158,
	"./Multimedia/dvd.png": 2159,
	"./Multimedia/equalizer.png": 2160,
	"./Multimedia/film.png": 2161,
	"./Multimedia/floppy-disk.png": 2162,
	"./Multimedia/game.png": 2163,
	"./Multimedia/ipod-shuffle.png": 2164,
	"./Multimedia/ipod.png": 2165,
	"./Multimedia/keyboard.png": 2166,
	"./Multimedia/loudspeaker-1.png": 2167,
	"./Multimedia/loudspeaker.png": 2168,
	"./Multimedia/memory-card.png": 2169,
	"./Multimedia/microphone-1.png": 2170,
	"./Multimedia/microphone.png": 2171,
	"./Multimedia/mobile-phone.png": 2172,
	"./Multimedia/modem.png": 2173,
	"./Multimedia/negative-film.png": 2174,
	"./Multimedia/negative.png": 2175,
	"./Multimedia/next-track.png": 2176,
	"./Multimedia/pause.png": 2177,
	"./Multimedia/photos.png": 2178,
	"./Multimedia/play.png": 2179,
	"./Multimedia/previous-track.png": 2180,
	"./Multimedia/radio.png": 2181,
	"./Multimedia/rec.png": 2182,
	"./Multimedia/speaker.png": 2183,
	"./Multimedia/stop.png": 2184,
	"./Multimedia/tablet.png": 2185,
	"./Multimedia/tv-1.png": 2186,
	"./Multimedia/tv.png": 2187,
	"./Multimedia/web-cam.png": 2188,
	"./Office/adhesive-tape.png": 2189,
	"./Office/bookshelf.png": 2190,
	"./Office/box.png": 2191,
	"./Office/briefcase.png": 2192,
	"./Office/business-card.png": 2193,
	"./Office/cabinet.png": 2194,
	"./Office/calculator.png": 2195,
	"./Office/calendar.png": 2196,
	"./Office/clipboard.png": 2197,
	"./Office/clock.png": 2198,
	"./Office/coffee-cup.png": 2199,
	"./Office/computer.png": 2200,
	"./Office/copy-machine.png": 2201,
	"./Office/documents.png": 2202,
	"./Office/fax.png": 2203,
	"./Office/folder-1.png": 2204,
	"./Office/folder-2.png": 2205,
	"./Office/folder.png": 2206,
	"./Office/garbage.png": 2207,
	"./Office/headphones.png": 2208,
	"./Office/highlighter.png": 2209,
	"./Office/hole-puncher.png": 2210,
	"./Office/id-card.png": 2211,
	"./Office/lamp.png": 2212,
	"./Office/laptop.png": 2213,
	"./Office/letters.png": 2214,
	"./Office/mail.png": 2215,
	"./Office/mouse.png": 2216,
	"./Office/mug.png": 2217,
	"./Office/note.png": 2218,
	"./Office/notebook-1.png": 2219,
	"./Office/notebook.png": 2220,
	"./Office/office-chair.png": 2221,
	"./Office/paper-shredder.png": 2222,
	"./Office/pen.png": 2223,
	"./Office/pencil-case.png": 2224,
	"./Office/pendrive.png": 2225,
	"./Office/plant.png": 2226,
	"./Office/presentation.png": 2227,
	"./Office/printer.png": 2228,
	"./Office/projector.png": 2229,
	"./Office/push-pin.png": 2230,
	"./Office/router.png": 2231,
	"./Office/rubber-stamp.png": 2232,
	"./Office/safebox.png": 2233,
	"./Office/stapler.png": 2234,
	"./Office/table.png": 2235,
	"./Office/telephone.png": 2236,
	"./Office/uniform.png": 2237,
	"./Office/webcam.png": 2238,
	"./Professions/astronaut.png": 2239,
	"./Professions/athlete.png": 2240,
	"./Professions/builder.png": 2241,
	"./Professions/carpenter.png": 2242,
	"./Professions/cashier.png": 2243,
	"./Professions/chef.png": 2244,
	"./Professions/chemist.png": 2245,
	"./Professions/clown.png": 2246,
	"./Professions/concierge.png": 2247,
	"./Professions/courier.png": 2248,
	"./Professions/detective.png": 2249,
	"./Professions/diver.png": 2250,
	"./Professions/dj.png": 2251,
	"./Professions/doctor.png": 2252,
	"./Professions/dyer.png": 2253,
	"./Professions/electrician.png": 2254,
	"./Professions/farmer.png": 2255,
	"./Professions/firefighter.png": 2256,
	"./Professions/fisherman.png": 2257,
	"./Professions/gardener.png": 2258,
	"./Professions/hairdresser.png": 2259,
	"./Professions/lumberjack.png": 2260,
	"./Professions/magician.png": 2261,
	"./Professions/maid.png": 2262,
	"./Professions/manager.png": 2263,
	"./Professions/mechanic.png": 2264,
	"./Professions/miner.png": 2265,
	"./Professions/nurse.png": 2266,
	"./Professions/painter.png": 2267,
	"./Professions/pensioner.png": 2268,
	"./Professions/personplaceholder.png": 216,
	"./Professions/photographer.png": 2269,
	"./Professions/pilot.png": 2270,
	"./Professions/plumber.png": 2271,
	"./Professions/policeman.png": 2272,
	"./Professions/politician.png": 2273,
	"./Professions/postman.png": 2274,
	"./Professions/priest.png": 2275,
	"./Professions/professor.png": 2276,
	"./Professions/programmer.png": 2277,
	"./Professions/sailor.png": 2278,
	"./Professions/secretary.png": 2279,
	"./Professions/showman.png": 2280,
	"./Professions/singer.png": 2281,
	"./Professions/soldier.png": 2282,
	"./Professions/stewardess.png": 2283,
	"./Professions/support.png": 2284,
	"./Professions/taxi-driver.png": 2285,
	"./Professions/teacher.png": 2286,
	"./Professions/waiter.png": 2287,
	"./Professions/writer.png": 2288,
	"./PublicTransport/Coach_Black.png": 2289,
	"./PublicTransport/Coach_Blue.png": 2290,
	"./PublicTransport/Coach_Green.png": 2291,
	"./PublicTransport/Coach_Grey.png": 2292,
	"./PublicTransport/Coach_Red.png": 2293,
	"./PublicTransport/Coach_Yellow.png": 2294,
	"./PublicTransport/CommuterBus_Black.png": 2295,
	"./PublicTransport/CommuterBus_Blue.png": 2296,
	"./PublicTransport/CommuterBus_Green.png": 2297,
	"./PublicTransport/CommuterBus_Grey.png": 2298,
	"./PublicTransport/CommuterBus_Red.png": 2299,
	"./PublicTransport/CommuterBus_Yellow.png": 2300,
	"./PublicTransport/Taxi_Black.png": 2301,
	"./PublicTransport/Taxi_Blue.png": 2302,
	"./PublicTransport/Taxi_Green.png": 2303,
	"./PublicTransport/Taxi_Grey.png": 2304,
	"./PublicTransport/Taxi_Red.png": 2305,
	"./PublicTransport/Taxi_Yellow.png": 2306,
	"./PublicTransport/TransitBus_Black.png": 2307,
	"./PublicTransport/TransitBus_Blue.png": 2308,
	"./PublicTransport/TransitBus_Green.png": 2309,
	"./PublicTransport/TransitBus_Grey.png": 2310,
	"./PublicTransport/TransitBus_Red.png": 2311,
	"./PublicTransport/TransitBus_Yellow.png": 2312,
	"./Safety/001-fire.png": 2313,
	"./Safety/002-umbrella.png": 2314,
	"./Safety/003-shield-1.png": 2315,
	"./Safety/004-lifebuoy.png": 2316,
	"./Safety/005-cone.png": 2317,
	"./Safety/006-eye.png": 2318,
	"./Safety/007-helmet.png": 2319,
	"./Safety/008-safety-belt.png": 2320,
	"./Safety/009-first-aid-kit.png": 2321,
	"./Safety/010-barbed-wire.png": 2322,
	"./Safety/011-shield.png": 2323,
	"./Safety/012-cctv-1.png": 2324,
	"./Safety/013-cctv.png": 2325,
	"./Safety/014-fire-alarm-1.png": 2326,
	"./Safety/015-hose.png": 2327,
	"./Safety/016-hydrant.png": 2328,
	"./Safety/017-flasher.png": 2329,
	"./Safety/018-kitchen-hood.png": 2330,
	"./Safety/019-air-compressor.png": 2331,
	"./Safety/020-gas-mask.png": 2332,
	"./Safety/021-carbon-monoxide.png": 2333,
	"./Safety/022-extinguisher.png": 2334,
	"./Safety/023-sprinkler.png": 2335,
	"./Safety/024-pull.png": 2336,
	"./Safety/025-fire-alarm.png": 2337,
	"./Safety/026-smoke-detector.png": 2338,
	"./Safety/027-safety-code.png": 2339,
	"./Safety/028-signal.png": 2340,
	"./Safety/029-strongbox.png": 2341,
	"./Safety/030-password.png": 2342,
	"./Safety/031-key.png": 2343,
	"./Safety/032-keyhole.png": 2344,
	"./Safety/033-exit-1.png": 2345,
	"./Safety/034-door.png": 2346,
	"./Safety/035-padlock-1.png": 2347,
	"./Safety/036-padlock.png": 2348,
	"./Safety/037-house.png": 2349,
	"./Safety/038-exit.png": 2350,
	"./Safety/039-bell.png": 2351,
	"./Safety/040-stop.png": 2352,
	"./Safety/041-radiation.png": 2353,
	"./Safety/042-forbidden.png": 2354,
	"./Safety/043-not-touch.png": 2355,
	"./Safety/044-no-smoking.png": 2356,
	"./Safety/045-no-fire.png": 2357,
	"./Safety/046-high-voltage.png": 2358,
	"./Safety/047-fire-sign.png": 2359,
	"./Safety/048-warning.png": 2360,
	"./Safety/049-bomb.png": 2361,
	"./Safety/050-antenna.png": 2362,
	"./Shipping/aeroplane.png": 2363,
	"./Shipping/barcode.png": 2364,
	"./Shipping/box-1.png": 2365,
	"./Shipping/box.png": 2366,
	"./Shipping/boxes.png": 2367,
	"./Shipping/calendar.png": 2368,
	"./Shipping/clipboard.png": 2369,
	"./Shipping/container.png": 2370,
	"./Shipping/delivery-1.png": 2371,
	"./Shipping/delivery-2.png": 2372,
	"./Shipping/delivery-3.png": 2373,
	"./Shipping/delivery-truck.png": 2374,
	"./Shipping/delivery.png": 2375,
	"./Shipping/envelope.png": 2376,
	"./Shipping/find.png": 2377,
	"./Shipping/fragile.png": 2378,
	"./Shipping/gift.png": 2379,
	"./Shipping/laptop.png": 2380,
	"./Shipping/package-1.png": 2381,
	"./Shipping/package-2.png": 2382,
	"./Shipping/package-3.png": 2383,
	"./Shipping/package-4.png": 2384,
	"./Shipping/package-5.png": 2385,
	"./Shipping/package-6.png": 2386,
	"./Shipping/package-7.png": 2387,
	"./Shipping/package.png": 2388,
	"./Shipping/route.png": 2389,
	"./Shipping/safety.png": 2390,
	"./Shipping/ship.png": 2391,
	"./Shipping/shipping.png": 2392,
	"./Shipping/smartphone.png": 2393,
	"./Shipping/stroller.png": 2394,
	"./Shipping/support.png": 2395,
	"./Shipping/train.png": 2396,
	"./Shipping/up.png": 2397,
	"./Shipping/warehouse-1.png": 2398,
	"./Shipping/warehouse-2.png": 2399,
	"./Shipping/warehouse.png": 2400,
	"./Shipping/weight.png": 2401,
	"./Shipping/worldwide.png": 2402,
	"./Tools/atomic.png": 2403,
	"./Tools/awl.png": 2404,
	"./Tools/axe.png": 2405,
	"./Tools/barrels.png": 2406,
	"./Tools/battery-1.png": 2407,
	"./Tools/battery.png": 2408,
	"./Tools/box.png": 2409,
	"./Tools/charging.png": 2410,
	"./Tools/chisel.png": 2411,
	"./Tools/clamp.png": 2412,
	"./Tools/coal.png": 2413,
	"./Tools/compass.png": 2414,
	"./Tools/cutter.png": 2415,
	"./Tools/driller.png": 2416,
	"./Tools/ecology.png": 2417,
	"./Tools/electric-car.png": 2418,
	"./Tools/electric-tower.png": 2419,
	"./Tools/eolic-energy.png": 2420,
	"./Tools/factory.png": 2421,
	"./Tools/faucet.png": 2422,
	"./Tools/file.png": 2423,
	"./Tools/gas-station.png": 2424,
	"./Tools/gas.png": 2425,
	"./Tools/glue.png": 2426,
	"./Tools/hammer-1.png": 2427,
	"./Tools/hammer-2.png": 2428,
	"./Tools/hammer.png": 2429,
	"./Tools/house.png": 2430,
	"./Tools/hydro-power.png": 2431,
	"./Tools/jigsaw.png": 2432,
	"./Tools/ladder.png": 2433,
	"./Tools/level.png": 2434,
	"./Tools/light-bulb.png": 2435,
	"./Tools/low-battery.png": 2436,
	"./Tools/marker.png": 2437,
	"./Tools/mat.png": 2438,
	"./Tools/measuring-tape.png": 2439,
	"./Tools/nail.png": 2440,
	"./Tools/needle.png": 2441,
	"./Tools/nut.png": 2442,
	"./Tools/oil-platform.png": 2443,
	"./Tools/paint-brush-1.png": 2444,
	"./Tools/paint-brush-2.png": 2445,
	"./Tools/paint-brush.png": 2446,
	"./Tools/paint-bucket.png": 2447,
	"./Tools/paint-palette.png": 2448,
	"./Tools/paint-roller.png": 2449,
	"./Tools/pantone.png": 2450,
	"./Tools/pencil.png": 2451,
	"./Tools/pliers-1.png": 2452,
	"./Tools/pliers-2.png": 2453,
	"./Tools/pliers.png": 2454,
	"./Tools/plug.png": 2455,
	"./Tools/power-button.png": 2456,
	"./Tools/power-plant.png": 2457,
	"./Tools/rain.png": 2458,
	"./Tools/recycle.png": 2459,
	"./Tools/renewable-energy-1.png": 2460,
	"./Tools/renewable-energy.png": 2461,
	"./Tools/ruler-1.png": 2462,
	"./Tools/ruler.png": 2463,
	"./Tools/save-energy.png": 2464,
	"./Tools/saw-1.png": 2465,
	"./Tools/saw.png": 2466,
	"./Tools/scissors.png": 2467,
	"./Tools/screw.png": 2468,
	"./Tools/screwdriver.png": 2469,
	"./Tools/set-square.png": 2470,
	"./Tools/shovel-1.png": 2471,
	"./Tools/shovel.png": 2472,
	"./Tools/socket.png": 2473,
	"./Tools/solar-energy.png": 2474,
	"./Tools/spatula.png": 2475,
	"./Tools/tape.png": 2476,
	"./Tools/toolbox.png": 2477,
	"./Tools/usb-cable.png": 2478,
	"./Tools/workplace.png": 2479,
	"./Tools/wrench-1.png": 2480,
	"./Tools/wrench-2.png": 2481,
	"./Tools/wrench.png": 2482,
	"./Traffic/001-highway-1.png": 2483,
	"./Traffic/002-two-ways.png": 2484,
	"./Traffic/003-road-sign.png": 2485,
	"./Traffic/004-barrier.png": 2486,
	"./Traffic/005-right-arrow.png": 2487,
	"./Traffic/006-roundabout.png": 2488,
	"./Traffic/007-prohibition.png": 2489,
	"./Traffic/008-curves.png": 2490,
	"./Traffic/009-intersection-3.png": 2491,
	"./Traffic/010-caravan-1.png": 2492,
	"./Traffic/011-caravan.png": 2493,
	"./Traffic/012-highway.png": 2494,
	"./Traffic/013-traffic-sign-1.png": 2495,
	"./Traffic/014-traffic-sign.png": 2496,
	"./Traffic/015-warning-2.png": 2497,
	"./Traffic/016-gas-station.png": 2498,
	"./Traffic/017-turn-right-2.png": 2499,
	"./Traffic/018-coffee-shop.png": 2500,
	"./Traffic/019-bicycle-1.png": 2501,
	"./Traffic/020-bicycle.png": 2502,
	"./Traffic/021-bump.png": 2503,
	"./Traffic/022-intersection-2.png": 2504,
	"./Traffic/023-turn-1.png": 2505,
	"./Traffic/024-turn-right-1.png": 2506,
	"./Traffic/025-turn-left-1.png": 2507,
	"./Traffic/026-intersection-1.png": 2508,
	"./Traffic/027-intersection.png": 2509,
	"./Traffic/028-waiting.png": 2510,
	"./Traffic/029-horn.png": 2511,
	"./Traffic/030-narrow-road.png": 2512,
	"./Traffic/031-warning-1.png": 2513,
	"./Traffic/032-hill.png": 2514,
	"./Traffic/033-truck.png": 2515,
	"./Traffic/034-pedestrian-2.png": 2516,
	"./Traffic/035-pedestrian-1.png": 2517,
	"./Traffic/036-traffic-light.png": 2518,
	"./Traffic/037-turn.png": 2519,
	"./Traffic/038-slippery.png": 2520,
	"./Traffic/039-no-entry.png": 2521,
	"./Traffic/040-speed-limit.png": 2522,
	"./Traffic/041-humps.png": 2523,
	"./Traffic/042-falling-rocks.png": 2524,
	"./Traffic/043-pedestrian.png": 2525,
	"./Traffic/044-turn-right.png": 2526,
	"./Traffic/045-turn-left.png": 2527,
	"./Traffic/046-u-turn.png": 2528,
	"./Traffic/047-warning.png": 2529,
	"./Traffic/048-no-parking.png": 2530,
	"./Traffic/049-parking.png": 2531,
	"./Traffic/050-danger.png": 2532,
	"./Trailers/BoxTrailer_Black.png": 2533,
	"./Trailers/BoxTrailer_Blue.png": 2534,
	"./Trailers/BoxTrailer_Green.png": 2535,
	"./Trailers/BoxTrailer_Grey.png": 2536,
	"./Trailers/BoxTrailer_Red.png": 2537,
	"./Trailers/BoxTrailer_Yellow.png": 2538,
	"./Trailers/Caravan_Black.png": 2539,
	"./Trailers/Caravan_Blue.png": 2540,
	"./Trailers/Caravan_Green.png": 2541,
	"./Trailers/Caravan_Grey.png": 2542,
	"./Trailers/Caravan_Red.png": 2543,
	"./Trailers/Caravan_Yellow.png": 2544,
	"./Trailers/FullTrailer_Black.png": 2545,
	"./Trailers/FullTrailer_Blue.png": 2546,
	"./Trailers/FullTrailer_Green.png": 2547,
	"./Trailers/FullTrailer_Grey.png": 2548,
	"./Trailers/FullTrailer_Red.png": 2549,
	"./Trailers/FullTrailer_Yellow.png": 2550,
	"./Trailers/SuperSilentGeneratorTrailer_Black.png": 2551,
	"./Trailers/SuperSilentGeneratorTrailer_Blue.png": 2552,
	"./Trailers/SuperSilentGeneratorTrailer_Green.png": 2553,
	"./Trailers/SuperSilentGeneratorTrailer_Grey.png": 2554,
	"./Trailers/SuperSilentGeneratorTrailer_Red.png": 2555,
	"./Trailers/SuperSilentGeneratorTrailer_Yellow.png": 2556,
	"./Trailers/TankerTrailer_Black.png": 2557,
	"./Trailers/TankerTrailer_Blue.png": 2558,
	"./Trailers/TankerTrailer_Green.png": 2559,
	"./Trailers/TankerTrailer_Grey.png": 2560,
	"./Trailers/TankerTrailer_Red.png": 2561,
	"./Trailers/TankerTrailer_Yellow.png": 2562,
	"./Trailers/TravelTrailer_Black.png": 2563,
	"./Trailers/TravelTrailer_Blue.png": 2564,
	"./Trailers/TravelTrailer_Green.png": 2565,
	"./Trailers/TravelTrailer_Grey.png": 2566,
	"./Trailers/TravelTrailer_Red.png": 2567,
	"./Trailers/TravelTrailer_Yellow.png": 2568,
	"./Trailers/WaterBowserTrailer_Black.png": 2569,
	"./Trailers/WaterBowserTrailer_Blue.png": 2570,
	"./Trailers/WaterBowserTrailer_Green.png": 2571,
	"./Trailers/WaterBowserTrailer_Grey.png": 2572,
	"./Trailers/WaterBowserTrailer_Red.png": 2573,
	"./Trailers/WaterBowserTrailer_Yellow.png": 2574,
	"./Transportation/aeroplane.png": 2575,
	"./Transportation/airplane.png": 2576,
	"./Transportation/auto-ricksaw.png": 2577,
	"./Transportation/bike.png": 2578,
	"./Transportation/boat.png": 2579,
	"./Transportation/bus-1.png": 2580,
	"./Transportation/bus.png": 2581,
	"./Transportation/cable-car-cabin.png": 2582,
	"./Transportation/car-1.png": 2583,
	"./Transportation/car-2.png": 2584,
	"./Transportation/car-3.png": 2585,
	"./Transportation/car.png": 2586,
	"./Transportation/catamaran.png": 2587,
	"./Transportation/chairlift.png": 2588,
	"./Transportation/classic-car.png": 2589,
	"./Transportation/helicopter.png": 2590,
	"./Transportation/hot-air-balloon.png": 2591,
	"./Transportation/jeep.png": 2592,
	"./Transportation/locomotive.png": 2593,
	"./Transportation/lorry.png": 2594,
	"./Transportation/minibus.png": 2595,
	"./Transportation/monorail.png": 2596,
	"./Transportation/motorbike.png": 2597,
	"./Transportation/quad.png": 2598,
	"./Transportation/sailboat.png": 2599,
	"./Transportation/sailing-ship.png": 2600,
	"./Transportation/school-bus.png": 2601,
	"./Transportation/ship-1.png": 2602,
	"./Transportation/ship-2.png": 2603,
	"./Transportation/ship-3.png": 2604,
	"./Transportation/ship.png": 2605,
	"./Transportation/sidecar.png": 2606,
	"./Transportation/spaceship.png": 2607,
	"./Transportation/sportive-car.png": 2608,
	"./Transportation/submarine.png": 2609,
	"./Transportation/taxi-1.png": 2610,
	"./Transportation/taxi.png": 2611,
	"./Transportation/tractor.png": 2612,
	"./Transportation/train-1.png": 2613,
	"./Transportation/train-2.png": 2614,
	"./Transportation/train.png": 2615,
	"./Transportation/tram.png": 2616,
	"./Transportation/tricycle.png": 2617,
	"./Transportation/trolleybus.png": 2618,
	"./Transportation/truck.png": 2619,
	"./Transportation/ufo.png": 2620,
	"./Transportation/underground.png": 2621,
	"./Transportation/van-1.png": 2622,
	"./Transportation/van.png": 2623,
	"./Transportation/zeppelin.png": 2624,
	"./Trucks/BinTruck_Black.png": 2625,
	"./Trucks/BinTruck_Blue.png": 2626,
	"./Trucks/BinTruck_Green.png": 2627,
	"./Trucks/BinTruck_Grey.png": 2628,
	"./Trucks/BinTruck_Red.png": 2629,
	"./Trucks/BinTruck_Yellow.png": 2630,
	"./Trucks/FuelTankTruck_Black.png": 2631,
	"./Trucks/FuelTankTruck_Blue.png": 2632,
	"./Trucks/FuelTankTruck_Green.png": 2633,
	"./Trucks/FuelTankTruck_Grey.png": 2634,
	"./Trucks/FuelTankTruck_Red.png": 2635,
	"./Trucks/FuelTankTruck_Yellow.png": 2636,
	"./Trucks/HaulTruck_Black.png": 2637,
	"./Trucks/HaulTruck_Blue.png": 2638,
	"./Trucks/HaulTruck_Green.png": 2639,
	"./Trucks/HaulTruck_Grey.png": 2640,
	"./Trucks/HaulTruck_Red.png": 2641,
	"./Trucks/HaulTruck_Yellow.png": 2642,
	"./Trucks/LorryCab_Black.png": 2643,
	"./Trucks/LorryCab_Blue.png": 2644,
	"./Trucks/LorryCab_Green.png": 2645,
	"./Trucks/LorryCab_Grey.png": 2646,
	"./Trucks/LorryCab_Red.png": 2647,
	"./Trucks/LorryCab_Yellow.png": 2648,
	"./Trucks/LorryTrailer_Black.png": 2649,
	"./Trucks/LorryTrailer_Blue.png": 2650,
	"./Trucks/LorryTrailer_Green.png": 2651,
	"./Trucks/LorryTrailer_Grey.png": 2652,
	"./Trucks/LorryTrailer_Red.png": 2653,
	"./Trucks/LorryTrailer_Yellow.png": 2654,
	"./Trucks/Lorry_Black.png": 2655,
	"./Trucks/Lorry_Blue.png": 2656,
	"./Trucks/Lorry_Green.png": 2657,
	"./Trucks/Lorry_Grey.png": 2658,
	"./Trucks/Lorry_Red.png": 2659,
	"./Trucks/Lorry_Yellow.png": 2660,
	"./Trucks/PetroleumTankTruck_Black.png": 2661,
	"./Trucks/PetroleumTankTruck_Blue.png": 2662,
	"./Trucks/PetroleumTankTruck_Green.png": 2663,
	"./Trucks/PetroleumTankTruck_Grey.png": 2664,
	"./Trucks/PetroleumTankTruck_Red.png": 2665,
	"./Trucks/PetroleumTankTruck_Yellow.png": 2666,
	"./Trucks/SkipTruck_Black.png": 2667,
	"./Trucks/SkipTruck_Blue.png": 2668,
	"./Trucks/SkipTruck_Green.png": 2669,
	"./Trucks/SkipTruck_Grey.png": 2670,
	"./Trucks/SkipTruck_Red.png": 2671,
	"./Trucks/SkipTruck_Yellow.png": 2672,
	"./Trucks/TankerTruck_Black.png": 2673,
	"./Trucks/TankerTruck_Blue.png": 2674,
	"./Trucks/TankerTruck_Green.png": 2675,
	"./Trucks/TankerTruck_Grey.png": 2676,
	"./Trucks/TankerTruck_Red.png": 2677,
	"./Trucks/TankerTruck_Yellow.png": 2678,
	"./Trucks/TractorTrailer2_Black.png": 2679,
	"./Trucks/TractorTrailer2_Blue.png": 2680,
	"./Trucks/TractorTrailer2_Green.png": 2681,
	"./Trucks/TractorTrailer2_Grey.png": 2682,
	"./Trucks/TractorTrailer2_Red.png": 2683,
	"./Trucks/TractorTrailer2_Yellow.png": 2684,
	"./Trucks/TractorTrailer_Black.png": 2685,
	"./Trucks/TractorTrailer_Blue.png": 2686,
	"./Trucks/TractorTrailer_Green.png": 2687,
	"./Trucks/TractorTrailer_Grey.png": 2688,
	"./Trucks/TractorTrailer_Red.png": 2689,
	"./Trucks/TractorTrailer_Yellow.png": 2690,
	"./Trucks/TruckV_Black.png": 2691,
	"./Trucks/TruckV_Blue.png": 2692,
	"./Trucks/TruckV_Green.png": 2693,
	"./Trucks/TruckV_Grey.png": 2694,
	"./Trucks/TruckV_Red.png": 2695,
	"./Trucks/TruckV_Yellow.png": 2696,
	"./Trucks/Truck_Black.png": 2697,
	"./Trucks/Truck_Blue.png": 2698,
	"./Trucks/Truck_Green.png": 2699,
	"./Trucks/Truck_Grey.png": 2700,
	"./Trucks/Truck_Red.png": 2701,
	"./Trucks/Truck_Yellow.png": 2702,
	"./Watercraft/Barge_Black.png": 2703,
	"./Watercraft/Barge_Blue.png": 2704,
	"./Watercraft/Barge_Green.png": 2705,
	"./Watercraft/Barge_Grey.png": 2706,
	"./Watercraft/Barge_Red.png": 2707,
	"./Watercraft/Barge_Yellow.png": 2708,
	"./Watercraft/Boat_Black.png": 2709,
	"./Watercraft/Boat_Blue.png": 2710,
	"./Watercraft/Boat_Gray.png": 2711,
	"./Watercraft/Boat_Green.png": 2712,
	"./Watercraft/Boat_Red.png": 2713,
	"./Watercraft/Boat_Yellow.png": 2714,
	"./Watercraft/BulkCarrier_Black.png": 2715,
	"./Watercraft/BulkCarrier_Blue.png": 2716,
	"./Watercraft/BulkCarrier_Green.png": 2717,
	"./Watercraft/BulkCarrier_Grey.png": 2718,
	"./Watercraft/BulkCarrier_Red.png": 2719,
	"./Watercraft/BulkCarrier_Yellow.png": 2720,
	"./Watercraft/Motorboat_Black.png": 2721,
	"./Watercraft/Motorboat_Blue.png": 2722,
	"./Watercraft/Motorboat_Green.png": 2723,
	"./Watercraft/Motorboat_Grey.png": 2724,
	"./Watercraft/Motorboat_Red.png": 2725,
	"./Watercraft/Motorboat_Yellow.png": 2726,
	"./Watercraft/Sailboat_Black.png": 2727,
	"./Watercraft/Sailboat_Blue.png": 2728,
	"./Watercraft/Sailboat_Green.png": 2729,
	"./Watercraft/Sailboat_Grey.png": 2730,
	"./Watercraft/Sailboat_Red.png": 2731,
	"./Watercraft/Sailboat_Yellow.png": 2732,
	"./Watercraft/Tanker_Black.png": 2733,
	"./Watercraft/Tanker_Blue.png": 2734,
	"./Watercraft/Tanker_Green.png": 2735,
	"./Watercraft/Tanker_Grey.png": 2736,
	"./Watercraft/Tanker_Red.png": 2737,
	"./Watercraft/Tanker_Yellow.png": 2738,
	"./Watercraft/WaterMotorcycle_Black.png": 2739,
	"./Watercraft/WaterMotorcycle_Blue.png": 2740,
	"./Watercraft/WaterMotorcycle_Green.png": 2741,
	"./Watercraft/WaterMotorcycle_Grey.png": 2742,
	"./Watercraft/WaterMotorcycle_Red.png": 2743,
	"./Watercraft/WaterMotorcycle_Yellow.png": 2744
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;